import { body } from "../../../text/quick-start";
import { body as bodyotp } from "../../../text/quick-start-otp";
import { body as bodysi } from "../../../text/quick-start-selfinsert";
import { body as bodysolo1 } from "../../../text/quick-start-solo";
import { body as bodysolo2 } from "../../../text/quick-start-solo-random";
import { body as bodybt } from "../../../text/quick-start-broken-telephone";

import { GameSettings } from "../../../types";
import React, { useContext } from "react";

import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import { useAppSelector } from "../../../redux/store";
import FormPage from "../../common/formpage/formpage";
import AvatarHeader from "../../common/avatar-header/avatar-header";
import { useGameFormData } from "../../../hooks/useGameFormData";
import { useGameForm } from "../../../hooks/useGameForm";
import { GameContext } from "../../../contexts";
import { useTranslation } from "react-i18next";
import { selectGameSettings } from "../../../redux/selectors";

const QuickStart = () => {
  const { submit } = useContext(GameContext);
  const formData = useGameFormData();

  const { t } = useTranslation("game", { keyPrefix: "quickStart" });

  const gameSettings = useAppSelector(selectGameSettings);

  // function handleClick(e: React.FormEvent<HTMLFormElement>) {
  //     e.preventDefault()
  //     onClick({code: "game/ready", body: {}})
  // }

  function gameSubmit() {
    return { code: "game/ready", body: {} };
  }

  function getHeader() {
    if (gameSettings.otp_mode) return t("headers.otp");
    if (gameSettings.self_insert_mode) return t("headers.selfInsert");
    if (gameSettings.hidden_history) return t("headers.missingHistory");
    if (gameSettings.solo_writing) {
      return gameSettings.self_shuffle
        ? t("headers.soloRandom")
        : t("headers.soloOtp");
    }
    return t("headers.default");
  }

  function getBody(settings: GameSettings) {
    if (gameSettings.otp_mode) return bodyotp.contentGOTIT(settings);
    if (gameSettings.self_insert_mode) return bodysi.contentGOTIT(settings);
    if (gameSettings.hidden_history) return bodybt.contentGOTIT(settings);
    if (gameSettings.solo_writing) {
      return gameSettings.self_shuffle
        ? bodysolo2.contentGOTIT(settings)
        : bodysolo1.contentGOTIT(settings);
    }
    return body.contentGOTIT(settings);
  }

  function getSubHeaders() {
    return [t("subheaders.default")];
  }

  const { handleSubmit, avatarHeaderProps } = useGameForm({
    gameSubmit,
    playerState: formData.playerState,
  });

  return (
    <Waitable
      playerActionHandler={submit}
      waitingFor={[GameStatus.GameStatusPostQuickStart]}
      waitHeader={t("waiting")}
    >
      <FormPage
        header={<AvatarHeader titles={[getHeader()]} {...avatarHeaderProps} />}
        {...formData}
        readyFlash
        subHeaders={getSubHeaders()}
        submitText={t("footer.submit")}
        onSubmit={handleSubmit}
      >
        <div className={"p-4"}>{getBody(gameSettings)}</div>
      </FormPage>
    </Waitable>
  );
};

export default QuickStart;
